/* FizzyIQ — Recipes page (.frec-).
   Opens/closes the native <dialog> recipe modals. Delegated handlers so
   it works for any number of recipe blocks; guarded so it only binds once. */
(function () {
  'use strict';

  if (window.__fizzyRecipesInit) return;
  window.__fizzyRecipesInit = true;

  function supportsModal(dlg) {
    return typeof dlg.showModal === 'function';
  }

  function openModal(dlg) {
    if (dlg.open) return;
    if (supportsModal(dlg)) {
      window.fizzyPopupMotion.open(dlg);
    } else {
      dlg.setAttribute('open', '');
      dlg.classList.add('frec-modal--fallback');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeModal(dlg) {
    if (typeof dlg.close === 'function' && dlg.open) {
      window.fizzyPopupMotion.close(dlg);
    } else {
      dlg.removeAttribute('open');
      onClosed(dlg);
    }
  }

  function onClosed(dlg) {
    document.body.style.overflow = '';
    var vids = dlg.querySelectorAll('video');
    for (var i = 0; i < vids.length; i++) {
      try { vids[i].pause(); } catch (e) { /* noop */ }
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var opener = t.closest('[data-frec-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-frec-open'));
      if (dlg) openModal(dlg);
      return;
    }

    var closer = t.closest('[data-frec-close]');
    if (closer) {
      var d = closer.closest('dialog.frec-modal');
      if (d) closeModal(d);
      return;
    }

    // Click on the backdrop: the event target is the <dialog> itself
    // (its content is fully covered by .frec-modal-inner / close button).
    if (t.matches('dialog.frec-modal')) closeModal(t);
  });

  // Native `close` event covers Esc + close(); restore scroll, pause video.
  var dialogs = document.querySelectorAll('dialog.frec-modal');
  for (var i = 0; i < dialogs.length; i++) {
    (function (dlg) {
      dlg.addEventListener('close', function () { onClosed(dlg); });
    })(dialogs[i]);
  }
})();
